<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form :inline="true" class="inline-form">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="searchFormInfo.creatTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="creatTimePickerChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模板名称">
            <el-input class="search-input" v-model="searchFormInfo.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select class="search-input" v-model="searchFormInfo.type" clearable>
              <el-option label="代理商" value="1"></el-option>
              <el-option label="商户" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select class="search-input" v-model="searchFormInfo.status" clearable>
              <el-option label="未使用" value="0"></el-option>
              <el-option label="已使用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button opt="add" icon="el-icon-plus" @click.native="createTemplateClick" label="创建"></auth-button>
          </el-form-item>
          <el-form-item>
            <a href="static/费率模板操作指引.docx" download>
              <div class="file-download-button">费率模板操作指引</div>
            </a>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table stripe style="width:100%;" v-loading="tableLoading" :data="templateList" :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column prop="fCreateTime" label="创建时间" align="center" min-width="180"></el-table-column>
        <el-table-column prop="fName" label="模板名称" align="center" min-width="240"></el-table-column>
        <el-table-column prop="fType" label="类型" align="center" min-width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.fType | formatTemplateType }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="fStatus" label="状态" align="center" min-width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.fStatus | formatTemplateStatus }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="fUpdateTime" label="更新时间" align="center" min-width="180"></el-table-column>
        <el-table-column label="操作" align="center" min-width="300">
          <template slot-scope="scope">
            <auth-button opt="edit_status" type="text" style="width: 80px;" :label="scope.row.fStatus === 1 ? '取消使用' : '使用' "  @click.native="handleChangeState(scope.$index, scope.row)"></auth-button>
            <auth-button opt="edit" type="text" label="编辑" @click.native="handleEdit(scope.$index, scope.row)"></auth-button>
            <auth-button opt="delete" type="text" label="删除" @click.native="handleDelete(scope.$index, scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination v-if="paginations.count > 0" class="pagination" :page-size="paginations.pageSize" layout="total, prev, pager, next, jumper" :total="paginations.count" :current-page="paginations.pageNo" @current-change="onChangeCurrentPage"></el-pagination>
    </el-col>
    <!-- 模板新增和编辑dialog -->
    <el-dialog :title="isCreateTemplate ? '创建模板' : '模板设置'" :visible.sync="templateInfoDialogVisible" width="1000px" @close="$refs.templateInfoform.resetFields()">
      <div v-loading="templateInfoDialogLoading">
        <el-form ref="templateInfoform" :rules="editTemplateInfoRules" :model="editTemplateInfo" label-width="80px" label-position="left">
          <el-form-item label="类型" prop="FType">
            <el-select v-model="editTemplateInfo.FType" @change="editTemplateTypeSelectChange">
              <el-option label="代理商" :value="1" v-if="isShowAgentSelect"></el-option>
              <el-option label="商户" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="聚合平台进件是否默认使用" label-width="200px" prop="FStatus">
            <el-radio-group v-model="editTemplateInfo.FStatus">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="模板名称" prop="FName">
            <el-input class="dialog-form-item" v-model="editTemplateInfo.FName"></el-input>
          </el-form-item>
        </el-form>
        <div>
          <h3>成本信息</h3>
          <div v-if="agentRuleType === '0' && editTemplateInfo.FType === 1">
            <el-form label-width="80px" label-position="left">
              <el-form-item label="分成比例" prop="fLowerDivideCent">
                <el-input class="dialog-form-item" v-model="editTemplateInfo.fLowerDivideCent" @blur="lowerDivideCentInputBlur(editTemplateInfo.fLowerDivideCent)">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="rate-table-view" v-else>
            <h4>刷卡费率</h4>
            <el-table :data="editTemplateInfo.posRateData" :span-method="editTemplateTableSpanMethod" border>
              <el-table-column prop="type" label="类型" align="center" width="65">
              </el-table-column>
              <el-table-column prop="d1Rate" label="D+1费率" align="center" min-width="160">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.d1Rate" @blur="posD1RateInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="d1MaxFee" align="center" label="D+1封顶手续费" min-width="160">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.d1MaxFee" v-if="scope.row.type === '借记卡'" @blur="posD1MaxFeeInputBlur(scope.row, scope.row.type)"></el-input>
                  <div v-else>——</div>
                </template>
              </el-table-column>
              <el-table-column prop="d0Rate" align="center" label="D+0费率" min-width="160">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.d0Rate" @blur="posD0RateInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="d0FixedFee" align="center" label="D+0单笔手续费" min-width="160">
                <template slot-scope="scope">
                  <el-input v-model="editTemplateInfo.posRateData[1].d0FixedFee" @blur="posD0FixedFeeInputBlur(scope.row, scope.row.type)"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="lowerDivideCent" align="center" label="额外收取下级分成比例" min-width="160" v-if="editTemplateInfo.FType === 1">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.lowerDivideCent" @blur="tableLowerDivideCentInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
            <h4>扫码费率</h4>
            <div class="lowerDiv" v-if="editTemplateInfo.FType === 1">
              <span>额外收取下级分成比例</span>
              <el-input v-model="editTemplateInfo.lowerDivideCent" @blur="tableLowerDivideCentInputBlur('', '', editTemplateInfo.lowerDivideCent)" class="lowerInput">
                <template slot="append">%</template>
              </el-input>
            </div>
            <el-table :data="editTemplateInfo.scanWechatTable" border size="small" align="center" style="width:1080px;">
              <el-table-column prop="type" label="微信费用" align="center">
                <el-table-column prop="extraType" label="费用类型" align="center"></el-table-column>
                <el-table-column prop="d1" label="D+1费率" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.d1" @blur="scanD1RateInputBlur(scope.row, 'weixin')">
                      <template slot="append">%</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="d0" label="D+0费率" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.d0" @blur="scanD1RateInputBlur(scope.row, 'weixin')">
                      <template slot="append">%</template>
                    </el-input>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-collapse v-model="showWechat" style="width:720px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="多通道费率" name="1">
                <el-table :data="editTemplateInfo.scanWechatMulti" border size="small" align="center" style="width:1080px;">
                  <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1L" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.rateKeyL)">
                        <el-input v-model="scope.row.d1L" @blur="scanD1RateInputBlur(scope.row, scope.row.typeLetterL, 'L')" :disabled="weixinRateKeyL(scope)">
                          <template slot="append">%</template>
                        </el-input>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1R" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.rateKeyR)">
                        <el-input v-model="scope.row.d1R" @blur="scanD1RateInputBlur(scope.row, scope.row.typeLetterR, 'R')" :disabled="weixinRateKeyR(scope)">
                          <template slot="append">%</template>
                        </el-input>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="showRihua" style="width:360px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="服饰日化费率" name="1">
                <el-row class="row">
                  <el-col class="item">费用类型</el-col>
                  <el-col class="item">D+1费率</el-col>
                </el-row>
                <el-row class="row">
                  <el-col class="item">服饰日化-借记卡</el-col>
                  <el-col class="item">
                    <el-input v-model="editTemplateInfo.wxCategoryDebitCommissionD1">
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row  class="row">
                  <el-col class="item">服饰日化-贷记卡</el-col>
                  <el-col class="item">
                    <el-input v-model="editTemplateInfo.wxCategoryCreditCommissionD1">
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-collapse-item>
            </el-collapse>
            <el-table :data="editTemplateInfo.scanAlipayTable" border size="small" align="center" style="width:1080px;">
              <el-table-column
                prop="type"
                label="支付宝费率"
                align="center">
                <el-table-column
                  prop="extraType"
                  label="费用类型"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="d1"
                  label="D+1费率"
                  align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.d1" @blur="scanD1RateInputBlur(scope.row, 'alipay')">
                      <template slot="append">%</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="d0"
                  label="D+0费率"
                  align="center">
                  <template slot-scope="scope">
                    <div class='templateClass'>
                      <input class='inputClass' style='padding:10px ' v-model="scope.row.d0" />
                      <span class='percentClass' slot="append">%</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <el-collapse v-model="showAlipay" style="width:720px;margin-bottom: 20px;border-bottom: none">
              <el-collapse-item title="多通道费率" name="1">
                <el-table :data="editTemplateInfo.scanAlipayMulti" border size="small" align="center" style="width:720px;">
                  <el-table-column prop="extraTypeL" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1L" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1L !== '--'" @click="clickExtraRate(scope.row.typeLetterL, scope.row.rateKeyL)">
                        <el-input v-model="scope.row.d1L" @blur="scanD1RateInputBlur(scope.row, scope.row.typeLetterL, 'L')" :disabled="aliRateKeyL(scope)">
                          <template slot="append">%</template>
                        </el-input>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="extraTypeR" label="费用类型" align="center"></el-table-column>
                  <el-table-column prop="d1R" label="D+1费率" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.d1R !== '--'" @click="clickExtraRate(scope.row.typeLetterR, scope.row.rateKeyR)">
                        <el-input v-model="scope.row.d1R" @blur="scanD1RateInputBlur(scope.row, scope.row.typeLetterR, 'R')" :disabled="aliRateKeyR(scope)">
                          <template slot="append">%</template>
                        </el-input>
                      </div>
                      <span v-else>——</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
            <h4>银联二维码费率</h4>
            <el-table :data="editTemplateInfo.unionpayRateData" :span-method="editTemplateTableSpanMethod" border>
              <el-table-column prop="type" label="类型" align="center" width="65"></el-table-column>
              <el-table-column prop="d1UpRate" label="D+1费率>1000元" align="center" min-width="145">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.d1UpRate" @blur="unionpayD1UpRateInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="d1MaxCharge" align="center" label="D+1封顶手续费" min-width="145">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.d1MaxCharge" v-if="scope.row.type === '借记卡'" @blur="unionpayD1MaxChargeInputBlur(scope.row, scope.row.type)"></el-input>
                  <div v-else>——</div>
                </template>
              </el-table-column>
              <el-table-column prop="d1LessRate" align="center" label="D+1费率≤1000元" min-width="140">
                <template slot-scope="scope">
                  <!-- <div>{{ scope.row.d1LessRate }}%</div> -->
                  <el-input v-model="scope.row.d1LessRate" @blur="unionpayD1LessRateInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="d0UpRate" align="center" label="D+0费率>1000元" min-width="145">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.d0UpRate" @blur="unionpayD0UpRateInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="d0LessRate" align="center" label="D+0费率≤1000元" min-width="140">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.d0LessRate" @blur="unionpayD0UpRateInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="lowerDivideCent" align="center" label="额外收取下级分成比例" min-width="150" v-if="editTemplateInfo.FType === 1">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.lowerDivideCent" @blur="tableLowerDivideCentInputBlur(scope.row, scope.row.type)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="templateInfoDialogVisible = false" >取 消</el-button>
        <el-button type="primary" icon="el-icon-edit" @click="editTemplateSaveClick">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime.js'
import { getTemplateManagementList, templateChangeStatus, templateDelete, templateAdd, templateUpdate, getMcFee } from '@/api/setting'
import { getAgFee } from '@/api/partner'
const topRateNum = 50 // 代理商成本、商户费率默认封顶值
const topFeeNum = 500 // 代理商成本、商户手续费默认封顶值
const rateTypeInfo = {
  借记卡: {
    rateType: 'Debit',
    maxFeeType: 'Max',
    fixedFeeType: ''
  },
  贷记卡: {
    rateType: 'Credit',
    maxFeeType: '',
    fixedFeeType: 'Fixed'
  },
  境外卡: {
    rateType: 'OverSeas',
    maxFeeType: '',
    fixedFeeType: ''
  },
  微信: {
    rateType: 'Wx'
  },
  支付宝: {
    rateType: 'Ali'
  }
}

export default {
  name: 'SaasRateTemplate',
  data () {
    return {
      loading: false,
      tableLoading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        name: '',
        type: '',
        status: ''
      },
      searchFormInfo: {
        creatTime: '',
        name: '',
        type: '',
        status: ''
      },
      templateList: [],
      agentRuleType: 0,
      countRate: 45,
      isCreateTemplate: false,
      templateInfoDialogVisible: false,
      templateInfoDialogLoading: false,
      editTemplateInfo: {
        FId: '',
        FStatus: '',
        FName: '',
        FType: '',
        lowerDivideCent: '', // 代理商费率模板，扫码的额外下级分成比例
        fLowerDivideCent: '',
        posRateData: [
          {
            type: '借记卡',
            d1Rate: '',
            d0Rate: '',
            d1MaxFee: '',
            d0FixedFee: '',
            fPosLowerDivideCent: ''
          },
          {
            type: '贷记卡',
            d1Rate: '',
            d0Rate: '',
            d1MaxFee: '',
            d0FixedFee: ''
          },
          {
            type: '境外卡',
            d1Rate: '',
            d0Rate: '',
            d1MaxFee: '',
            d0FixedFee: ''
          }
        ],
        scanWechatTable: [
          {
            d1: '',
            d0: '',
            d0Rate: '',
            extraType: '线下(默认)'
          }
        ],
        scanWechatMulti: [
          {
            extraTypeL: '绿洲',
            d1L: '',
            rateKeyL: 'oasis',
            typeLetterL: 'weixin',
            extraTypeR: '公益',
            d1R: '',
            rateKeyR: 'publicWeal',
            typeLetterR: 'weixin'
          },
          {
            extraTypeL: '高校食堂',
            d1L: '',
            rateKeyL: 'collegeCanteen',
            typeLetterL: 'weixin',
            extraTypeR: '公缴',
            d1R: '',
            rateKeyR: 'publicPayment',
            typeLetterR: 'weixin'
          },
          {
            extraTypeL: '私立中小幼',
            d1L: '',
            rateKeyL: 'privateSchool',
            typeLetterL: 'weixin',
            extraTypeR: '保险',
            d1R: '',
            rateKeyR: 'insurance',
            typeLetterR: 'weixin'
          },
          {
            extraTypeL: '线上',
            d1L: '',
            rateKeyL: 'online',
            typeLetterL: 'weixin',
            extraTypeR: '——',
            d1R: '--',
            typeLetterR: 'weixin'
          }
        ],
        scanAlipayTable: [
          {
            d1: '',
            d0Rate: '',
            extraType: '线下（默认）'
          }
        ],
        scanAlipayMulti: [
          {
            extraTypeL: '线上',
            d1L: '',
            rateKeyL: 'online',
            typeLetterL: 'alipay',
            extraTypeR: '蓝海活动',
            d1R: '',
            rateKeyR: 'bluesea',
            typeLetterR: 'alipay'
          },
          {
            extraTypeL: '行业活动0',
            d1L: '',
            rateKeyL: 'activityFee0',
            typeLetterL: 'alipay',
            extraTypeR: '行业活动1',
            d1R: '',
            rateKeyR: 'activityFee1',
            typeLetterR: 'alipay'
          }
        ],
        unionpayRateData: [
          {
            type: '借记卡',
            d1UpRate: '',
            d1MaxCharge: '',
            d0UpRate: '',
            d1LessRate: '',
            d0LessRate: '',
            fUnionLowerDivideCent: ''
          },
          {
            type: '贷记卡',
            d1UpRate: '',
            d1MaxCharge: '',
            d0UpRate: '',
            d1LessRate: '',
            d0LessRate: ''
          }
        ],
        wxCategoryDebitCommissionD1: '',
        wxCategoryCreditCommissionD1: ''
      },
      editTemplateInfoRules: {
        FStatus: [
          { required: true, type: 'number', message: '请选择是否默认使用', trigger: 'change' }
        ],
        FName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
          { max: 15, message: '长度在 15 个字符以内', trigger: 'blur' },
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }
        ],
        FType: [
          { required: true, type: 'number', message: '请选择模板类型', trigger: 'change' }
        ]
      },
      minRateData: {},
      minAgentRateData: {},
      minMerchantData: {},
      showAlipay: [],
      showWechat: [],
      showRihua: []
    }
  },
  mounted () {
    this.searchClick()
    this.getAgentRate()
    this.getMerchantRate()
  },
  methods: {
    /**
     * 选择时间change回调
     */
    creatTimePickerChange (value) {
      console.log(value, parseTime(new Date(), '{y}-{m}-{d}'))
      if (value[1].split(' ')[0] === parseTime(new Date(), '{y}-{m}-{d}')) {
        value[1] = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
      } else if (value[1].split(' ')[1] === '00:00:00') {
        value[1] = value[1].split(' ')[0] + ' 23:59:59'
      }
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.searchInfo.startTime = this.searchFormInfo.creatTime && this.searchFormInfo.creatTime[0] ? this.searchFormInfo.creatTime[0] : ''
      this.searchInfo.endTime = this.searchFormInfo.creatTime && this.searchFormInfo.creatTime[1] ? this.searchFormInfo.creatTime[1] : ''
      this.searchInfo.name = this.searchFormInfo.name || ''
      this.searchInfo.type = this.searchFormInfo.type || ''
      this.searchInfo.status = this.searchFormInfo.status || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
      this.getTemplateManagementList()
    },
    /**
     * 删除提交参数中的空字段
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 重置填写模板费率
     */
    resetEditTemplateRate (type) {
      this.editTemplateInfo = this.$options.data().editTemplateInfo
      if (this.agentRuleType === '0' && type === 1) {
        this.editTemplateInfo.FStatus = 0
        this.editTemplateInfo.FName = ''
        this.editTemplateInfo.FType = type
        this.editTemplateInfo.fLowerDivideCent = ''
      } else {
        const templateType = type || (this.isShowAgentSelect ? 1 : 2)
        const d0DefaultRate = templateType === 1 ? 0.6 : 1
        this.editTemplateInfo.FStatus = 0
        this.editTemplateInfo.FName = ''
        this.editTemplateInfo.FType = templateType
        this.editTemplateInfo.scanWechatTable[0].d0Rate = d0DefaultRate
        this.editTemplateInfo.scanAlipayTable[0].d0Rate = d0DefaultRate
        this.editTemplateInfo.unionpayRateData[0].d0UpRate = d0DefaultRate
        this.editTemplateInfo.unionpayRateData[0].d0LessRate = d0DefaultRate
        this.editTemplateInfo.unionpayRateData[1].d0UpRate = d0DefaultRate
        this.editTemplateInfo.unionpayRateData[1].d0LessRate = d0DefaultRate
      }
    },
    /**
     * 新增/编辑模板费率table合并行方法
     */
    editTemplateTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === 'D+0单笔手续费') {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    /**
       * 新增/编辑模板费率table合并行方法-扫码费率特殊处理
       */
    editTemplateTableSpanMethod2 ({ row, column, rowIndex, columnIndex }) {
      if (column.label === '额外收取下级分成比例') {
        if (rowIndex === 0) {
          return {
            rowspan: 13,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.label === '类型') {
        if (rowIndex === 0) {
          return {
            rowspan: 8,
            colspan: 1
          }
        } else if (rowIndex === 8) {
          return {
            rowspan: 5,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    /**
     * 创建模板按钮点击
     */
    createTemplateClick () {
      this.resetEditTemplateRate()
      this.minRateData = this.minAgentRateData
      this.isCreateTemplate = true
      this.templateInfoDialogVisible = true
    },
    /**
     * 修改使用状态按钮点击
     */
    handleChangeState (index, row) {
      console.log('修改使用状态', index, row)
      this.$confirm(`确认${row.fStatus ? '取消' : ''}使用该模板?`, '提示', {
        type: 'warning'
      }).then(() => {
        this.templateChangeStatusFn(row.fId, 1 ^ row.fStatus)
      })
    },
    /**
     * 删除模板按钮点击
     */
    handleDelete (index, row) {
      console.log('删除模板', index, row)
      this.$confirm('确认删除该模板?', '提示', {
        type: 'warning'
      }).then(() => {
        this.templateDeleteFn(row.fId)
      })
    },
    /**
     * 编辑模板按钮点击
     */
    handleEdit (index, row) {
      console.log('编辑模板', index, row)
      this.transformRateInfoToEditInfo(row)
      this.minRateData = row.fType === 1 ? this.minAgentRateData : this.minMerchantData
      this.isCreateTemplate = false
      this.templateInfoDialogVisible = true
    },
    /**
     * 分成比例输入blur回调
     */
    lowerDivideCentInputBlur () {
      const fLowerDivideCent = this.editTemplateInfo.fLowerDivideCent
      console.log(fLowerDivideCent)
      if (fLowerDivideCent < 0 || fLowerDivideCent > 100 || Number(fLowerDivideCent) % 1 !== 0) {
        this.$message({
          showClose: true,
          message: '分成比例不能是小数，小于0或者大于100',
          type: 'warning'
        })
        this.editTemplateInfo.fLowerDivideCent = ''
      }
    },
    /**
     * 刷卡D1费率输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    posD1RateInputBlur (row, rateType) {
      const rate = row.d1Rate
      const minRate = this.minRateData.pos[`t1${rateTypeInfo[rateType].rateType}Commission`] / 100
      console.log(rate, `t1${rateTypeInfo[rateType].rateType}Commission`, minRate, topRateNum)
      if (!rate || rate < minRate || rate > topRateNum) {
        this.$message({
          showClose: true,
          message: `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`,
          type: 'warning'
        })
        row.d1Rate = minRate
      }
    },
    /**
     * 刷卡D1封顶手续费输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    posD1MaxFeeInputBlur (row, rateType) {
      const fee = row.d1MaxFee
      const minFee = this.minRateData.pos[`t1${rateTypeInfo[rateType].rateType}MaxFee`] / 1000000
      console.log(fee, minFee, topFeeNum)
      if (!fee || fee < minFee || fee > topFeeNum) {
        this.$message({
          showClose: true,
          message: `手续费不能为空、小于默认手续费 或 超过${topFeeNum}元`,
          type: 'warning'
        })
        row.d1MaxFee = minFee
      }
    },
    /**
     * 刷卡D0费率输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    posD0RateInputBlur (row, rateType) {
      const rate = row.d0Rate
      const minRate = this.minRateData.pos[`t0${rateTypeInfo[rateType].rateType}Commission`] / 100
      console.log(rate, `t0${rateTypeInfo[rateType].rateType}Commission`, minRate, topRateNum)
      if (!rate || rate < minRate || rate > topRateNum) {
        this.$message({
          showClose: true,
          message: `D0费率不能为空 或 大于${topRateNum}% 或小于默认费率`,
          type: 'warning'
        })
        row.d0Rate = minRate
      }
    },
    /**
     * 刷卡D1单笔手续费输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    posD0FixedFeeInputBlur (row, rateType) {
      const fee = this.editTemplateInfo.posRateData[1].d0FixedFee
      const minFee = this.minRateData.pos.t0FixFee / 1000000
      console.log(fee, `t0${rateTypeInfo[rateType].fixedFeeType}Fee`, minFee, topFeeNum)
      if (!fee || fee < minFee || fee > topFeeNum) {
        this.$message({
          showClose: true,
          message: `手续费不能为空、小于默认手续费 或 超过${topFeeNum}元`,
          type: 'warning'
        })
        this.editTemplateInfo.posRateData[1].d0FixedFee = minFee
      }
    },
    /**
     * 额外收取下级分成比例输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     * @param {Number} value 费率值
     */
    tableLowerDivideCentInputBlur (row, rateType, value) {
      const lowerDivideCent = value || row.lowerDivideCent
      console.log(lowerDivideCent)
      if (lowerDivideCent < 0 || lowerDivideCent > 100 || Number(lowerDivideCent) % 1 !== 0) {
        this.$message({
          showClose: true,
          message: '额外收取下级分成比例不能是小数，小于0或者大于100',
          type: 'warning'
        })
        // row.lowerDivideCentrow = 0
        // row.lowerDivideCent = 0
      }
    },
    /**
     * 扫码D1费率输入blur回调
     * @param {Number} row 当前行数据
     * @param {String} type 费率类型，weixin、alipay
     * @param {String} multiType 多通道费率当前字段是左还是右L R
     */
    scanD1RateInputBlur (row, type, multiType) {
      console.log('🚀 ~ file: saasRateTemplate.vue ~ line 1037 ~ scanD1RateInputBlur ~ row', row)
      let rate, minRate
      type = type.substr(0, 1).toUpperCase() + type.substr(1)
      if (multiType) {
        rate = row['d1' + multiType]
        if (this.minRateData.scan.extraFeeRate) {
          const extraFeeRate = JSON.parse(this.minRateData.scan.extraFeeRate)
          minRate = type === 'Weixin'
            ? extraFeeRate.wechat[row['rateKey' + multiType]] / 100
            : extraFeeRate.alipay[row['rateKey' + multiType]] / 100
        }
      } else {
        multiType = ''
        rate = row.d1
        minRate = this.minRateData.scan[`t1${type}Commission`] / 100
        console.log(rate, `t1${type}Commission`, minRate, topRateNum)
      }
      if (!rate || rate < minRate || rate > topRateNum) {
        this.$message({
          showClose: true,
          message: `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`,
          type: 'warning'
        })
        row['d1' + multiType] = minRate
      }
    },
    /**
     * 扫码D0费率输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    scanD0RateInputBlur (row, rateType) {
      const rate = row.d0Rate
      let type
      switch (rateTypeInfo[rateType].rateType) {
        case 'Wx':
          type = 'Weixin'
          break
        case 'Ali':
          type = 'Alipay'
          break
        default:
          type = 'Weixin'
          break
      }
      const minRate = this.minRateData.scan[`t0${type}Commission`] / 100
      console.log(rate, `t0${type}Commission`, minRate, topRateNum)
      if (!rate || rate < minRate || rate > topRateNum) {
        this.$message({
          showClose: true,
          message: `D0费率不能为空 或 大于${topRateNum}% 或小于默认费率`,
          type: 'warning'
        })
        row.d0Rate = minRate
      }
    },
    /**
     * 银联D1费率>1000输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    unionpayD1UpRateInputBlur (row, rateType) {
      const rate = row.d1UpRate
      const minRate = this.minRateData.unionpay[`fT1${rateTypeInfo[rateType].rateType}CommissionBymillion`] / 100
      console.log(rate, `fT1${rateTypeInfo[rateType].rateType}CommissionBymillion`, minRate, topRateNum)
      if (!rate || rate < minRate || rate > topRateNum) {
        this.$message({
          showClose: true,
          message: `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`,
          type: 'warning'
        })
        row.d1UpRate = minRate
      }
      // row.d1LessRate = Number(row.d1UpRate * this.countRate / 100).toFixed(2)
    },
    /**
     * 银联D封顶手续费输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    unionpayD1MaxChargeInputBlur (row, rateType) {
      const fee = row.d1MaxCharge
      const minFee = this.minRateData.unionpay[`fT1${rateTypeInfo[rateType].rateType}MaxFeeBymillion`] / 1000000
      console.log(fee, `fT1${rateTypeInfo[rateType].rateType}MaxFeeBymillion`, minFee, topFeeNum)
      if (!fee || fee < minFee || fee > topFeeNum) {
        this.$message({
          showClose: true,
          message: `手续费不能为空、小于默认手续费 或 超过${topFeeNum}元`,
          type: 'warning'
        })
        row.d1MaxCharge = minFee
      }
    },
    /**
     * 银联D0费率>1000输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    unionpayD0UpRateInputBlur (row, rateType) {
      const rate = row.d0UpRate
      const minRate = this.minRateData.unionpay[`fT0${rateTypeInfo[rateType].rateType}CommissionBymillion`] / 100
      console.log(rate, `fT0${rateTypeInfo[rateType].rateType}CommissionBymillion`, minRate, topRateNum)
      if (!rate || rate < minRate || rate > topRateNum) {
        this.$message({
          showClose: true,
          message: `D0费率不能为空 或 大于${topRateNum}% 或小于默认费率`,
          type: 'warning'
        })
        row.d0UpRate = minRate
      }
      // row.d0LessRate = Number(row.d0UpRate * this.countRate / 100).toFixed(2)
    },
    /**
     * 银联D1费率<=1000输入blur回调
     * @param {Object} row 当前行对象
     * @param {String} rateType 费率类型
     */
    unionpayD1LessRateInputBlur (row, rateType) {
      const rate = row.d1LessRate
      // const minRate = (this.minRateData.unionpay[`fT0${rateTypeInfo[rateType].rateType}CommissionBymillion`] / 100 * this.countRate / 100).toFixed(2)
      const minRate = (this.minRateData.unionpay[`fT1${rateTypeInfo[rateType].rateType}CommissionBymillionLevel2`] / 100).toFixed(2)
      console.log(rate, minRate, topRateNum)
      if (!rate || rate < minRate || rate > topRateNum) {
        this.$message({
          showClose: true,
          message: `D1费率不能为空 或 大于${topRateNum}% 或小于默认费率`,
          type: 'warning'
        })
        row.d1LessRate = minRate
      }
    },
    /**
     * 新增/编辑模板类型选择change
     */
    editTemplateTypeSelectChange (value) {
      this.resetEditTemplateRate(value)
      this.minRateData = value === 1 ? this.minAgentRateData : this.minMerchantData
    },
    /**
     * 新增/编辑模板保存按钮点击
     */
    editTemplateSaveClick () {
      let templateInfoformValid = false
      this.$refs.templateInfoform.validate((valid) => {
        templateInfoformValid = valid
        return valid
      })
      if (!templateInfoformValid) {
        this.$message({
          showClose: true,
          message: '请设置正确的模板信息',
          type: 'warning'
        })
        return
      }
      const rateInfo = this.transformEditInfoToRateInfo()
      let hasAllRate = true
      for (const key in rateInfo) {
        // eslint-disable-next-line no-prototype-builtins
        if (rateInfo.hasOwnProperty(key)) {
          const element = rateInfo[key]
          if (key !== 'FStatus' && key !== 'FName' && key !== 'FType' && key !== 'FId' && !element && element !== 0) {
            hasAllRate = false
            break
          }
        }
      }
      if (!hasAllRate) {
        this.$message({
          showClose: true,
          message: '请输入正确的费率',
          type: 'warning'
        })
        return
      }
      this.$confirm(`确认${this.isCreateTemplate ? '创建' : '编辑'}该模板?`, '提示', {
        type: 'warning'
      }).then(() => {
        if (this.isCreateTemplate) {
          this.templateAddFn(rateInfo)
        } else {
          this.templateUpdateFn(rateInfo)
        }
      })
    },
    /**
     * 把获取到的费率信息转换为展示用对象
     */
    transformRateInfoToEditInfo (row) {
      this.editTemplateInfo.FId = row.fId
      this.editTemplateInfo.FStatus = row.fStatus
      this.editTemplateInfo.FName = row.fName
      this.editTemplateInfo.FType = row.fType
      if (this.agentRuleType === '0' && row.fType === 1) {
        this.editTemplateInfo.fLowerDivideCent = this.transformToFakeRate(row.fLowerDivideCent)
      } else {
        const posRateData = [
          {
            type: '借记卡'
          },
          {
            type: '贷记卡'
          },
          {
            type: '境外卡'
          }
        ]
        posRateData.forEach((element, index) => {
          element.d1Rate = this.transformToFakeRate(row[`fT1${rateTypeInfo[element.type].rateType}Rate`])
          element.d0Rate = this.transformToFakeRate(row[`fT0${rateTypeInfo[element.type].rateType}Rate`])
          element.d1MaxFee = this.transformToFakeFee(row[`fT1${rateTypeInfo[element.type].rateType}Fee${rateTypeInfo[element.type].maxFeeType}`])
          element.d0FixedFee = this.transformToFakeFee(row[`fT0${rateTypeInfo[element.type].fixedFeeType}Fee`])
          if (index === 0) {
            element.lowerDivideCent = this.transformToFakeRate(row.fPosLowerDivideCent)
          }
        })
        const fExtraData = row.fExtraData ? JSON.parse(row.fExtraData) : {}
        if (row.fExtraData) {
          this.editTemplateInfo.scanWechatMulti.forEach(element => {
            element.d1L = element.extraTypeL !== '——' ? this.transformToFakeRate(fExtraData.wechat[element.rateKeyL]) : '--'
            element.d1R = element.extraTypeR !== '——' ? this.transformToFakeRate(fExtraData.wechat[element.rateKeyR]) : '--'
          })
          this.editTemplateInfo.scanAlipayMulti.forEach(element => {
            element.d1L = element.extraTypeL !== '——' ? this.transformToFakeRate(fExtraData.alipay[element.rateKeyL]) : '--'
            element.d1R = element.extraTypeR !== '——' ? this.transformToFakeRate(fExtraData.alipay[element.rateKeyR]) : '--'
          })
        }
        this.editTemplateInfo.scanWechatTable[0].d0 = this.transformToFakeRate(row.fWxT0Rate)
        this.editTemplateInfo.scanAlipayTable[0].d0 = this.transformToFakeRate(row.fAliT0Rate)
        this.editTemplateInfo.scanWechatTable[0].d1 = this.transformToFakeRate(row.fWxT1Rate)
        this.editTemplateInfo.scanAlipayTable[0].d1 = this.transformToFakeRate(row.fAliT1Rate)
        this.editTemplateInfo.lowerDivideCent = this.transformToFakeRate(row.fScanLowerDivideCent)
        const unionpayRateData = [
          {
            type: '借记卡'
          },
          {
            type: '贷记卡'
          }
        ]
        unionpayRateData.forEach((element, index) => {
          element.d1UpRate = this.transformToFakeRate(row[`fT1Unionpay${rateTypeInfo[element.type].rateType}Rate`])
          element.d1MaxCharge = this.transformToFakeFee(row[`fT1Unionpay${rateTypeInfo[element.type].rateType}MaxCharge`])
          element.d0UpRate = this.transformToFakeRate(row[`fT0Unionpay${rateTypeInfo[element.type].rateType}Rate`])
          element.d0LessRate = this.transformToFakeRate(row[`fT0Unionpay${rateTypeInfo[element.type].rateType}RateLv2`])
          element.d1LessRate = this.transformToFakeRate(row[`fT1Unionpay${rateTypeInfo[element.type].rateType}RateLv2`])
          // element.d0LessRate = this.transformToFakeRate(row[`fT0Unionpay${rateTypeInfo[element.type].rateType}RateLv2`])
          if (index === 0) {
            element.lowerDivideCent = this.transformToFakeRate(row.fUnionLowerDivideCent)
          }
        })
        this.editTemplateInfo.posRateData = posRateData
        this.editTemplateInfo.unionpayRateData = unionpayRateData
        // 日化
        this.editTemplateInfo.wxCategoryDebitCommissionD1 = this.transformToFakeRate(row.wxCategoryDebitCommissionD1)
        this.editTemplateInfo.wxCategoryCreditCommissionD1 = this.transformToFakeRate(row.wxCategoryCreditCommissionD1)
      }
    },
    /**
     * 把展示用对象转换为提交参数用对象
     */
    transformEditInfoToRateInfo () {
      console.log(this.editTemplateInfo)
      const templateInfo = {
        FStatus: this.editTemplateInfo.FStatus,
        FName: this.editTemplateInfo.FName,
        FType: this.editTemplateInfo.FType
      }
      if (this.editTemplateInfo.FId) {
        templateInfo.FId = this.editTemplateInfo.FId
      }
      if (this.agentRuleType === '0' && this.editTemplateInfo.FType === 1) {
        templateInfo.FLowerDivideCent = this.transformToRealRate(this.editTemplateInfo.fLowerDivideCent)
      } else {
        if (this.editTemplateInfo.FType === 1) {
          templateInfo.FPosLowerDivideCent = ''
          templateInfo.FScanLowerDivideCent = ''
          templateInfo.FUnionLowerDivideCent = ''
        }
        templateInfo.FT1DebitFeeMax = ''
        templateInfo.FT0FixedFee = ''
        templateInfo.FT1UnionpayDebitMaxCharge = ''
        this.editTemplateInfo.posRateData.forEach(element => {
          templateInfo[`FT1${rateTypeInfo[element.type].rateType}Rate`] = this.transformToRealRate(element.d1Rate)
          templateInfo[`FT0${rateTypeInfo[element.type].rateType}Rate`] = this.transformToRealRate(element.d0Rate)
          if (element.d1MaxFee && !isNaN(element.d1MaxFee)) {
            templateInfo.FT1DebitFeeMax = this.transformToRealFee(element.d1MaxFee)
          }
          if (element.d0FixedFee && !isNaN(element.d0FixedFee)) {
            templateInfo.FT0FixedFee = this.transformToRealFee(element.d0FixedFee)
          }
          if (this.editTemplateInfo.FType === 1 && (element.lowerDivideCent || element.lowerDivideCent === 0) && !isNaN(element.lowerDivideCent)) {
            templateInfo.FPosLowerDivideCent = this.transformToRealRate(element.lowerDivideCent)
          }
        })
        const fExtraData = {
          alipay: {},
          wechat: {}
        }
        templateInfo.FWxT1Rate = this.transformToRealRate(this.editTemplateInfo.scanWechatTable[0].d1)
        templateInfo.FWxT0Rate = this.transformToRealRate(this.editTemplateInfo.scanWechatTable[0].d0)
        templateInfo.FAliT1Rate = this.transformToRealRate(this.editTemplateInfo.scanAlipayTable[0].d1)
        templateInfo.FAliT0Rate = this.transformToRealRate(this.editTemplateInfo.scanAlipayTable[0].d0)
        const scanLowerDivideCent = this.editTemplateInfo.lowerDivideCent
        if (this.editTemplateInfo.FType === 1 && (scanLowerDivideCent || scanLowerDivideCent === 0) && !isNaN(scanLowerDivideCent)) {
          templateInfo.FScanLowerDivideCent = this.transformToRealRate(scanLowerDivideCent)
        }
        this.editTemplateInfo.scanWechatMulti.forEach(element => {
          fExtraData.wechat[element.rateKeyL] = this.transformToRealRate(element.d1L)
          fExtraData.wechat[element.rateKeyR] = this.transformToRealRate(element.d1R)
        })
        this.editTemplateInfo.scanAlipayMulti.forEach(element => {
          fExtraData.alipay[element.rateKeyL] = this.transformToRealRate(element.d1L)
          fExtraData.alipay[element.rateKeyR] = this.transformToRealRate(element.d1R)
        })
        this.editTemplateInfo.unionpayRateData.forEach(element => {
          templateInfo[`FT1Unionpay${rateTypeInfo[element.type].rateType}Rate`] = this.transformToRealRate(element.d1UpRate)
          templateInfo[`FT0Unionpay${rateTypeInfo[element.type].rateType}Rate`] = this.transformToRealRate(element.d0UpRate)
          templateInfo[`fT1Unionpay${rateTypeInfo[element.type].rateType}RateLv2`] = this.transformToRealRate(element.d1LessRate)
          templateInfo[`fT0Unionpay${rateTypeInfo[element.type].rateType}RateLv2`] = this.transformToRealRate(element.d0LessRate)
          // templateInfo[`fT1Unionpay${rateTypeInfo[element.type].rateType}RateLv2`] = this.transformToRealRate(element.d0LessRate)
          if (element.d1MaxCharge && !isNaN(element.d1MaxCharge)) {
            templateInfo.FT1UnionpayDebitMaxCharge = this.transformToRealFee(element.d1MaxCharge)
          }
          if (this.editTemplateInfo.FType === 1 && (element.lowerDivideCent || element.lowerDivideCent === 0) && !isNaN(element.lowerDivideCent)) {
            templateInfo.FUnionLowerDivideCent = this.transformToRealRate(element.lowerDivideCent)
          }
        })
        templateInfo.fExtraData = JSON.stringify(fExtraData)

        // 日化
        templateInfo.wxCategoryDebitCommissionD1 = this.transformToRealRate(this.editTemplateInfo.wxCategoryDebitCommissionD1)
        templateInfo.wxCategoryCreditCommissionD1 = this.transformToRealRate(this.editTemplateInfo.wxCategoryCreditCommissionD1)
      }
      console.log(templateInfo)
      return templateInfo
    },
    /**
     * 转换为展示费率
     */
    transformToFakeRate (rate) {
      if (rate !== '' && rate !== undefined && rate !== null) {
        return parseFloat(Number(rate / 10000).toFixed(2))
      } else {
        return ''
      }
    },
    /**
     * 转换为展示手续费
     */
    transformToFakeFee (fee) {
      return parseFloat(Number(fee / 1000000).toFixed(2))
    },
    /**
     * 转换为提交费率
     */
    transformToRealRate (rate) {
      if (rate !== '' && rate !== undefined && rate !== null) {
        return parseInt(Number(rate * 10000).toFixed(0))
      } else {
        return ''
      }
    },
    /**
     * 转换为提交手续费
     */
    transformToRealFee (fee) {
      return parseInt(Number(fee * 1000000).toFixed(0))
    },
    /**
     * 获取模板列表
     */
    getTemplateManagementList () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      getTemplateManagementList(params).then(response => {
        this.loading = false
        console.log('getTemplateManagementList response:', response)
        if (response.error_code === '0') {
          this.agentRuleType = response.ruleType
          this.countRate = parseInt(response.fRate)
          this.templateList = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 获取代理商默认费率
     */
    getAgentRate () {
      getAgFee('').then(response => {
        console.log('getAgentRate response', response)
        if (response.error_code === '0') {
          this.minAgentRateData = response
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 获取商户默认费率
     */
    getMerchantRate () {
      getMcFee('').then(response => {
        console.log('getMerchantRate response', response)
        if (response.error_code === '0') {
          this.minMerchantData = response.minCommission
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 更改模板使用状态
     */
    templateChangeStatusFn (id, status) {
      this.loading = true
      const params = qs.stringify({
        id: id,
        status: status
      })
      console.log(params)
      templateChangeStatus(params).then(response => {
        console.log('templateChangeStatus response:', response)
        if (response.error_code === '0') {
          this.$message({
            message: '更新使用状态成功',
            type: 'success'
          })
          this.searchClick()
        } else {
          this.loading = false
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 删除模板
     */
    templateDeleteFn (id) {
      this.loading = true
      const params = qs.stringify({
        id: id
      })
      console.log(params)
      templateDelete(params).then(response => {
        console.log('templateDelete response:', response)
        if (response.error_code === '0') {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.searchClick()
        } else {
          this.loading = false
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 新增模板
     */
    templateAddFn (rateInfo) {
      this.templateInfoDialogLoading = true
      const params = qs.stringify(rateInfo)
      console.log(params)
      templateAdd(params).then(response => {
        console.log('templateAdd response:', response)
        this.templateInfoDialogLoading = false
        if (response.error_code === '0') {
          this.$message({
            message: '新增模板成功',
            type: 'success'
          })
          this.templateInfoDialogVisible = false
          this.searchClick()
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 修改模板
     */
    templateUpdateFn (rateInfo) {
      this.templateInfoDialogLoading = true
      const params = qs.stringify(rateInfo)
      console.log(params)
      templateUpdate(params).then(response => {
        console.log('templateUpdate response:', response)
        this.templateInfoDialogLoading = false
        if (response.error_code === '0') {
          this.$message({
            message: '修改模板成功',
            type: 'success'
          })
          this.templateInfoDialogVisible = false
          this.searchClick()
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    clickExtraRate (type, key) {
      const extraFeeRate = this.minRateData.scan.extraFeeRate
        ? JSON.parse(this.minRateData.scan.extraFeeRate)
        : ''
      type = type === 'weixin' ? 'wechat' : 'alipay'
      if (extraFeeRate === '' || typeof extraFeeRate[type][key] !== 'number') {
        this.$message({
          showClose: true,
          message: '上级代理商未开通此通道交易，无法设置费率',
          type: 'warning'
        })
      }
    }
  },
  computed: {
    isShowAgentSelect () {
      const userData = this.$store.getters.userInfo
      const agentLevel = userData.userEntity.fAgentLevel
      const parentAgentLevel = userData.userEntity.parentAgentLevel || 0
      return parentAgentLevel + (agentLevel === 9 ? 0 : 1) < 6
    },
    weixinRateKeyL () {
      return (scope) => {
        return !this.minRateData.scan.extraFeeRate || typeof JSON.parse(this.minRateData.scan.extraFeeRate).wechat[scope.row.rateKeyL] !== 'number'
      }
    },
    weixinRateKeyR () {
      return (scope) => {
        return !this.minRateData.scan.extraFeeRate || typeof JSON.parse(this.minRateData.scan.extraFeeRate).wechat[scope.row.rateKeyR] !== 'number'
      }
    },
    aliRateKeyL () {
      return (scope) => {
        return !this.minRateData.scan.extraFeeRate || typeof JSON.parse(this.minRateData.scan.extraFeeRate).alipay[scope.row.rateKeyL] !== 'number'
      }
    },
    aliRateKeyR () {
      return (scope) => {
        return !this.minRateData.scan.extraFeeRate || typeof JSON.parse(this.minRateData.scan.extraFeeRate).alipay[scope.row.rateKeyR] !== 'number'
      }
    }
  },
  filters: {
    formatTemplateType (value) {
      switch (value) {
        case 1:
          return '代理商'
        case 2:
          return '商户'
        default:
          return '未知'
      }
    },
    formatTemplateStatus (value) {
      switch (value) {
        case 0:
          return '未使用'
        case 1:
          return '已使用'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.search-input {
  width: 160px;
}
.dialog-form-item {
  width: 260px;
}
.rate-table-view {
  margin-left: 15px;
}
.file-download-button {
  color: #409EFF;
  margin: 0 10px;
}
h3 {
  margin-bottom: 25px;
}
h4 {
  margin-top: 20px;
  margin-bottom: 15px;
}
.row {
  display: flex;
  .item {
    padding: 8px;
    width: 180px;
    box-sizing: content-box;
    text-align:center;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    &:first-child {
      border-left: 1px solid #EBEEF5;
    }
  }
}
</style>
<style lang="scss">
.templateClass {
  display: flex;
}
.inputClass {
      -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 75%;
}
.percentClass {
      background-color: #F5F7FA;
    color: #909399;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 0 30px;
    width: 1px;
    white-space: nowrap;
}
.rate-table-view{
    .el-collapse-item__header{
        border-left: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
        padding-left: 20px;
        line-height: 1;
        background: #F5F7FA;
        color: #909399;
    }
    .el-collapse-item__wrap{
        border-bottom: none;
    }
    .el-collapse-item__arrow {
        margin: 0 8px 0 10px;
    }
    .lowerDiv{
        margin-bottom: 20px;
        span{
            vertical-align: bottom;
            line-height: 40px;
            margin-right: 30px;
        }
        .lowerInput{
            width: 200px;
        }
    }
}
</style>
